import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Form,
    FormGroup,
    InputGroup,
    Input,
    Button
} from "reactstrap";

import { Link } from "react-router-dom";

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";

import { withTranslation } from "react-i18next";

import { toggleRightSidebar } from "../../store/actions";

import logosmdark from "../../assets/images/favicon.ico";
import logodark from "../../assets/images/logodark.png";
import logosmlight from "../../assets/images/favicon.ico";
import logolight from "../../assets/images/favicon.ico";

const Header = ({ t, toggleMenuCallback }) => {
    const [isSearch, setIsSearch] = useState(false);

    const dispatch = useDispatch();
    const layoutType = useSelector((state) => state.Layout.layoutType);

    const toggleMenu = () => {
        toggleMenuCallback();
    };

    const toggleRightbar = () => {
        dispatch(toggleRightSidebar());
    };

    const toggleFullscreen = () => {
        if (
            !document.fullscreenElement &&
            !document.mozFullScreenElement &&
            !document.webkitFullscreenElement
        ) {
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(
                    Element.ALLOW_KEYBOARD_INPUT
                );
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    };

    return (
        <React.Fragment>
            <header id="page-topbar">
                <div className="navbar-header">
                    <div className="d-flex">
                        <div className="navbar-brand-box">
                            <Link to="#" className="logo logo-dark">
                                <span className="logo-sm">
                                    <img src={logosmdark} alt="" height="22" />
                                </span>
                                <span className="logo-lg">
                                    <img src={logodark} alt="" height="20" />
                                </span>
                            </Link>

                            <Link to="#" className="logo logo-light">
                                <span className="logo-sm">
                                    <img src={logosmlight} alt="" height="22" />
                                </span>
                                <span className="logo-lg">
                                    <img src={logolight} alt="" height="20" />
                                </span>
                            </Link>
                        </div>

                        <Button
                            size="sm"
                            color="none"
                            type="button"
                            onClick={toggleMenu}
                            className="px-3 font-size-24 header-item waves-effect"
                            id="vertical-menu-btn"
                        >
                            <i className="ri-menu-2-line align-middle"></i>
                        </Button>

                        <Form className="app-search d-none d-lg-block">
                            <div className="position-relative">
                                <Input
                                    type="text"
                                    className="form-control"
                                    placeholder={t("Search")}
                                />
                                <span className="ri-search-line"></span>
                            </div>
                        </Form>
                    </div>

                    <div className="d-flex">
                        <div className="dropdown d-inline-block d-lg-none ms-2">
                            <button
                                type="button"
                                onClick={() => setIsSearch(!isSearch)}
                                className="btn header-item noti-icon waves-effect"
                                id="page-header-search-dropdown"
                            >
                                <i className="ri-search-line"></i>
                            </button>
                            <div
                                className={
                                    isSearch
                                        ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                                        : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                                }
                                aria-labelledby="page-header-search-dropdown"
                            >
                                <Form className="p-3">
                                    <FormGroup className="m-0">
                                        <InputGroup>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                placeholder={t("Search")}
                                            />
                                            <div className="input-group-append">
                                                <Button color="primary" type="submit">
                                                    <i className="ri-search-line"></i>
                                                </Button>
                                            </div>
                                        </InputGroup>
                                    </FormGroup>
                                </Form>
                            </div>
                        </div>

                        {/* <LanguageDropdown /> */}

                        <div className="dropdown d-none d-lg-inline-block ms-1">
                            <Button
                                color="none"
                                type="button"
                                className="header-item noti-icon waves-effect"
                                onClick={toggleFullscreen}
                            >
                                <i className="ri-fullscreen-line"></i>
                            </Button>
                        </div>

                        <NotificationDropdown />

                        <ProfileMenu />

                        <div className="dropdown d-inline-block">
                            <Button
                                color="none"
                                onClick={toggleRightbar}
                                type="button"
                                className="header-item noti-icon right-bar-toggle waves-effect"
                            >
                                <i className="ri-settings-2-line"></i>
                            </Button>
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default withTranslation()(Header);
